<template>
    <div id="lrbg_layout">
        <el-scrollbar class="write_scrollbar">
            <div class="lrbg_container">
                <div class="lrbg_aside">
                    <div class="aside_part">
                        <div class="aside_logo">
                            <img class="logo_img" src="./img/logo4.png" alt="" srcset="">
                        </div>
                        <div class="aside_nav">
                            <router-link active-class="active" class="nav_item" to="/recently">
                                <div class="nav_content"><img class="nav_icon" src="./img/img_icon_01.png">最近文档</div>
                            </router-link>
                            <router-link active-class="active" class="nav_item" to="/stardoc">
                                <div class="nav_content"><img class="nav_icon" src="./img/img_icon_02.png">星标文档</div>
                            </router-link>
                        </div>
                    </div>
                    <div class="aside_part">
                        <div class="aside_title">通用写作</div>
                        <div class="aside_nav">
                            <router-link active-class="active" exact class="nav_item" to="/essaywriting?tplid=19&m=a">
                                <div class="nav_content"><img class="nav_icon" src="./img/img_icon_03.png">短文写作</div>
                            </router-link>
                            <router-link active-class="active" class="nav_item" to="/longwriting">
                                <div class="nav_content"><img class="nav_icon" src="./img/img_icon_04.png">长文写作</div>
                            </router-link>
                        </div>
                    </div>
                    <div class="aside_part flex_grow1">
                        <div class="aside_title">应用模版<img @click="showApps()" class="title_icon" src="./img/img_icon_09.png" alt=""></div>
                        <div class="nav_list">
                            <el-scrollbar class="aside_nav write_scrollbar">
                                <router-link active-class="active" exact class="nav_item" :to="'/essaywriting?tplid='+app.app_id" v-for="(app,idx) in myFaveriteTemplatelist" :key="app.app_id">
                                    <div class="nav_content"><img class="nav_icon" :src="app.app_icon">{{app.app_name}}<img v-if="app.app_id&&isLogin" @click.prevent="delMyFaverite(idx)" src="./img/img_icon_10.png" class="delete_icon"></div>
                                </router-link>
                                <div class="nav_item">
                                    <div class="nav_content more_app" @click="showApps()"><img class="nav_icon" src="./img/more_app.png">全部应用</div>
                                </div>
                            </el-scrollbar>
                        </div>
                    </div>
                    <div class="aside_part">
                        <div class="aside_title">会员权益
                            <el-popover placement="right-end" :offset="20" width="380" trigger="hover">
                                <div class="about_us">
                                    <div class="about_title">关于我们</div>
                                    <div class="about_content">
                                        <div class="content_p">懒得爬楼，于是人们发明了电梯，懒得去调电视机，于是有了遥控器，懒得去听音乐会，于是有了唱片··.···历史证明，“懒人”总喜欢化繁为简，是“懒人”推动了人类的进步!</div>
                                        <div class="content_p">懒人并非是真的“懒人”，而是为了提高工作效率，去寻找最有效的方法!</div>
                                        <div class="content_p">懒人办公的诞生，让我们可以在几分钟内完成文案写作、文案策划等等文字创作，让文字工作化繁为简，让你有大量的时间来给生活加点儿料，让你的幸福感不会因为工作而消失不见……</div>
                                    </div>
                                    <div class="about_footer">懒人办公 - 我们致力于解放您的大脑和双手！</div>
                                </div>
                                <img class="title_icon" slot="reference" src="./img/img_icon_11.png" alt="">
                            </el-popover>
                        </div>
                        <div class="aside_nav">
                            <router-link active-class="active" exact class="nav_item" to="/membership">
                                <div class="nav_content"><img class="nav_icon" src="./img/img_icon_12.png">升级会员</div>
                            </router-link>
                            <router-link active-class="active" exact class="nav_item" to="/recycle">
                                <div class="nav_content"><img class="nav_icon" src="./img/img_icon_13.png">回收站</div>
                            </router-link>
                        </div>
                    </div>
                    <div class="user_info" v-if="!isLogin">
                        <img class="avatar" src="./img/img_icon_17.png" >
                        <div class="user_info_right">
                            <div class="no_login" @click="checkLogin">未登录，点此登录</div>
                        </div>
                    </div>
                    <!-- 个人资料 -->
                    <el-popover placement="right-end" v-else width="400" ref="userInfoPop" trigger="click">
                        <div class="user_info" slot="reference">
                            <img class="avatar" :src="userInfo.avatarurl || df_avatar" >
                            <div class="user_info_right">
                                <div class="is_login">
                                    <div class="info_detail">
                                        <div class="user_name">{{ userInfo.nickname ? userInfo.nickname : "微信用户" }}</div>
                                        <div :class="['vip_icon','is_vip_'+userInfo.vip_type]"></div>
                                            <div class="user_tag" v-if="userInfo.utype==2">学生</div>
                                            <div class="user_tag" v-if="userInfo.utype==3">教师</div>
                                            <div class="user_tag" v-if="userInfo.utype==3">教师</div>
                                            <div class="user_tag" v-if="userInfo.utype==1&&userInfo.company_id>0">企业</div>
                                            <div class="user_tag" v-if="userInfo.utype==1&&userInfo.company_id==0">个人</div>
                                    </div>
                                    <div class="notice_badge">
                                        <img class="notice_icon" src="./img/img_icon_14.png" alt="">
                                        <!-- <div class="badge_num"></div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="user_info_pabel">
                            <div class="panel_top">
                                <img class="panel_avatar" :src="userInfo.avatarurl || df_avatar" >
                                <div class="panel_user_info">
                                    <div class="user_name">
                                        <div class="name_text">{{ userInfo.nickname ? userInfo.nickname : "微信用户" }}</div>
                                        <div :class="['vip_icon','is_vip_'+userInfo.vip_type]"></div>
                                            <div class="user_tag" v-if="userInfo.utype==2">学生</div>
                                            <div class="user_tag" v-if="userInfo.utype==3">教师</div>
                                            <div class="user_tag" v-if="userInfo.utype==1&&userInfo.company_id>0">企业</div>
                                            <div class="user_tag" v-if="userInfo.utype==1&&userInfo.company_id==0">个人</div>
                                    </div>
                                    <div class="user_desc" v-if="userInfo.uid">ID：{{userInfo.uid}}</div>
                                </div>
                                <!--未设置认证身份-->
                                <el-popover placement="right-start" width="200" :offset="-15" trigger="click">
                                    <div class="exchange_panel">
                                        <div class="part_title">当前身份</div>
                                            <div :class="['part_item', identity==1?'active':'']" @click="selectIdentity(1, '个人会员')">
                                                <img class="identy_icon select" src="./img/img_icon_17.png" alt="">
                                                <img class="identy_icon" src="./img/img_icon_78.png" alt="">个人会员
                                                <img class="select_icon" src="./img/img_icon_85.png" alt="">
                                            </div>
                                            <div :class="['part_item', identity==4?'active':'']" @click="selectIdentity(4, '企业会员')">
                                                <img class="identy_icon select" src="./img/img_icon_86.png" alt="">
                                                <img class="identy_icon" src="./img/img_icon_87.png" alt="">企业会员
                                                <img class="select_icon" src="./img/img_icon_85.png" alt="">
                                            </div>
                                            <div class="part_title">切换身份</div>
                                            <div :class="['part_item', identity==2?'active':'']" @click="selectIdentity(2, '学生身份')">
                                                <img class="identy_icon select" src="./img/img_icon_83.png" alt="">
                                                <img class="identy_icon" src="./img/img_icon_79.png" alt="">学生身份
                                                <img class="select_icon" src="./img/img_icon_85.png" alt="">
                                            </div>
                                            <div :class="['part_item', identity==3?'active':'']" @click="selectIdentity(3, '教师身份')">
                                                <img class="identy_icon select" src="./img/img_icon_84.png" alt="">
                                                <img class="identy_icon" src="./img/img_icon_80.png" alt="">教师身份
                                                <img class="select_icon" src="./img/img_icon_85.png" alt="">
                                            </div>
                                    </div>
                                    <div class="exchange_btn" slot="reference"><img class="exchange_icon" src="./img/img_icon_21.png" alt="">
                                        <template v-if="userInfo.utype==2">学生会员</template>
                                        <template v-if="userInfo.utype==3">教师会员</template>
                                        <template v-if="userInfo.utype==1&&userInfo.company_id>0">企业会员</template>
                                        <template v-if="userInfo.utype==1&&userInfo.company_id==0">个人会员</template>
                                    </div>
                                </el-popover>
                              
                                <!--团队管理员-->
                                <img class="manager_icon" src="./img/img_icon_22.png" alt="" v-if="userInfo.is_company_admin&&userInfo.company_id>0">
                            </div>
                            <div class="panel_content">
                                <div class="compony_btns" v-if="userInfo.is_company_admin&&userInfo.company_id>0">
                                    <div class="btn_item" @click="showMenber"><img class="btn_icon" src="./img/img_icon_74.png" alt="">团队成员</div>
                                    <div class="btn_item" @click="showDataPanel"><img class="btn_icon" src="./img/img_icon_75.png" alt="">数据看板</div>
                                    <div class="btn_item" @click="showInvite"><img class="btn_icon" src="./img/img_icon_76.png" alt="">邀请成员</div>
                                </div>
                                <div class="compony_btns" v-else>
                                    <div class="btn_item" @click="showKeyExchange"><img class="btn_icon" src="./img/img_icon_100.png" alt="">卡密兑换</div>
                                    <div class="btn_item" @click="showFreeMenber"><img class="btn_icon" src="./img/img_icon_101.png" alt="">免费会员</div>
                                    <div class="btn_item" @click="showCommunication"><img class="btn_icon" src="./img/img_icon_102.png" alt="">交流社区</div>
                                </div>
                                <div class="vip_level">会员等级：{{userInfo.vip_name}}（{{userInfo.vip_end_date}}）<div class="vip_btn" @click="gotoPay">续费</div></div>
                                <div class="vip_content">
                                    <div class="content_item">
                                        <div class="item_num">{{ profileData.today_writes }}</div>
                                        <div class="item_label">今日创作文档</div>
                                    </div>
                                    <div class="content_item">
                                        <div class="item_num">{{ profileData.total_writes }}</div>
                                        <div class="item_label">累计文档创作</div>
                                    </div>
                                    <div class="content_item">
                                        <div class="item_num">{{ profileData.today_write_words }}</div>
                                        <div class="item_label">今日创作字数</div>
                                    </div>
                                    <div class="content_item">
                                        <div class="item_num">{{ profileData.today_left_words }}</div>
                                        <div class="item_label">今日剩余字数</div>
                                    </div>
                                </div>
                                <div class="server_part">
                                    <div class="server_label"><img class="server_icon" src="./img/img_icon_18.png" alt=""><a target="_blank" href="https://work.weixin.qq.com/kfid/kfca95b63b3ea2e4f6f?enc_scene=ENCFWLrS8yW37WtvXn9GxBJQJ">人工客服</a></div>
                                    <div class="server_time">工作日周一到周五09:00-18:00在线</div>
                                </div>
                            </div>
                            <div class="panel_footer">
                                <div class="footer_btn" @click="showSetting"><img class="setting_icon" src="./img/img_icon_19.png" alt="">设置</div>
                                <div class="footer_btn" @click="logout"><img class="setting_icon" src="./img/img_icon_20.png" alt="">退出登录</div>
                            </div>
                        </div>
                        
                    </el-popover>
                </div>
                <div class="lrbg_main">
                    <router-view></router-view>
                </div>
            </div>
        </el-scrollbar>
        <transition name="fade">
            <div class="cover" v-show="drawer"></div>
        </transition>
        <transition name="bottom_slide">
            <div class="app_drawer" v-show="drawer">
                <div class="drawer_close">
                    <div class="close_btn" @click="drawer=false"><img class="close_icon" src="./img/img_icon_51.png" alt="">关闭窗口</div>
                    <img class="down_icon" src="./img/img_icon_57.png" alt="">
                </div>
                <div class="drawer_top">
                    <div class="app_nav">
                        <div @click="fetchAppsByCate(cate.id, i)" :class="['nav_item',{'active':activeNav==i}]" v-for="(cate, i) in appCateList">
                            <el-badge :value="cate.num">
                                <div class="nav_icon">
                                    <img :src="cate.logo_url" alt="">
                                </div>
                            </el-badge>
                            <div class="nav_title">{{ cate.name }}</div>
                        </div>
                    </div>
                    <div class="app_search">
                        <div class="search_wrap">
                            <input class="search_input" @keyup.enter="searchApp" type="text" v-model="app_name" placeholder="请输入关键词，比如“朋友圈文案”">
                            <img @click="searchApp" class="search_icon" src="./img/img_icon_66.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="drawer_content">
                    <el-scrollbar class="write_scrollbar">
                        <div class="scroll_content">
                            <el-row :gutter="20">
                                <el-col :span="48" v-for="ex in examp_list" :key="ex.id" style="margin-bottom:20px;">
                                    <div class="exmple_item">
                                        <div class="item_content" @click="selectExample(ex)">
                                            <img class="item_icon" :src="ex.app_icon" alt="">
                                            <div class="item_text">
                                                <div class="item_title">{{ ex.app_name }}</div>
                                                <div class="item_desc">{{ ex.app_desc }}</div>
                                            </div>
                                        </div>
                                        <div class="item_footer">
                                            <div class="footer_item">使用 {{ ex.use_num }} 次</div>
                                            <div class="footer_item add_btn" @click="addMyFaverite(ex)"><img class="footer_icon" src="./img/img_icon_56.png" alt="">{{ex.is_faverite==1?"已添加":"添加到我的"}}</div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </transition>
        <!-- 系统公告 -->
		<el-dialog center :visible.sync="noticeVisible" width="780px" :close-on-click-modal="false" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">系统公告</div>
				<div class="close_btn" @click="closeNitice"><img class="close_icon" src="./img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content notice_panel">
                <el-scrollbar class="write_scrollbar">
                    <div class="notice_head">亲爱的用户朋友们：</div>
                    <div class="notice_content">{{ userInfo.notice?userInfo.notice.content:"" }}</div>
                    <div class="notice_sign">懒人办公团队<br/>{{userInfo.notice?userInfo.notice.date:""}}</div>
                </el-scrollbar>
            </div>
			<div slot="footer" class="dialog_footer">
				<button class="notice_btn" @click="closeNitice">好的，我知道了</button>
			</div>
		</el-dialog>
        <!-- 团队成员 -->
		<el-dialog center :visible.sync="menberVisible" @close="showUserInfoPop" width="780px" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">团队成员<span style="font-size:12px;color:#999;">（{{menber_list.length}}人）</span></div>
				<div class="close_btn" @click="menberVisible = false"><img class="close_icon" src="./img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content menber_panel">
                <div class="menber_content">
                    <el-scrollbar class="write_scrollbar">
                        <el-table :data="menber_list" style="width: 100%">
                            <el-table-column label="成员">
                                <template slot-scope="scope">
                                    <img class="user_portrait" :src="scope.row.avatarurl?scope.row.avatarurl:df_avatar" alt="">
                                    {{ scope.row.real_name }}
                                    <span :class="['menber_type',{'manager':scope.row.is_admin==1}]">{{ scope.row.is_admin==1?"管理员":"成员" }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="join_date" label="加入时间"></el-table-column>
                            <el-table-column width="60" align="center" label="操作">
                                <template slot-scope="scope">
                                    <img @click="removeMenber(scope.row.id)" class="table_icon" src="./img/img_icon_77.png" alt="">
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-scrollbar>
                </div>
                <div class="panel_bottom">
                    注：如果购买名额是满的，那么当日踢出人数后，需次日才可加入新人！例如：购买了5个名额，已经加入了5个成员，如果踢出去一个成员，需要次日方可信任加入！如果名额未满，不受影响！
                </div>
            </div>
		</el-dialog>
         <!-- 个人资料设置 -->
		<el-dialog center :visible.sync="settingVisible" @close="showUserInfoPop" width="780px" :close-on-click-modal="false" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">资料设置</div>
				<div class="close_btn" @click="settingVisible = false"><img class="close_icon" src="./img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content form_panel">
                <el-form ref="setting_form" :rules="settingRules" :model="setting_form" label-width="80px" size="medium">
                    <el-form-item label="我的昵称" prop="real_name">
                        <el-input v-model="setting_form.real_name" style="width:360px;"></el-input>
                    </el-form-item>
                    <el-form-item label="个性头像" prop="avatarurl">
                        <div class="upload_wrap">
                            <div class="img_wrap">
                                <i class="el-icon-plus" v-if="!setting_form.avatarurl&&!uploading"></i>
                                <img v-if="setting_form.avatarurl" :src="setting_form.avatarurl" alt="">
                                <input class="upload_file_input" ref="fileInput" accept="image/*" type="file" @change="inputUpload($event,'setting_form')" title="">
                                <div class="uploading" v-if="uploading">
                                    正在上传，请稍后
                                    <img class="loading_pic" src="./img/loading.gif" alt="">
                                </div>
                            </div>
                            <div class="upload_tips">尺寸200×200，大小1M以内</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="phone">
                        <el-input v-model="setting_form.phone" style="width:360px;"></el-input>
                    </el-form-item>
                    <el-form-item label="我的邮箱" prop="email">
                        <el-input v-model="setting_form.email" style="width:360px;"></el-input>
                    </el-form-item>
                    <el-form-item label="联系地址" prop="address">
                        <el-input v-model="setting_form.address" style="width:360px;"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="button" class="submit_btn" @click="settingSubmit" :loading="saveLoading">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
		</el-dialog>
        <!-- 新建企业资料 -->
		<el-dialog center :visible.sync="enterpriseVisible" width="780px" @close="showUserInfoPop" :close-on-click-modal="false" :show-close="false" :destroy-on-close="true">
			<div class="dialog_title" slot="title">
				<div class="title_text">企业资料</div>
				<div class="close_btn" @click="enterpriseVisible = false"><img class="close_icon" src="./img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content form_panel">
                <el-form ref="enterprise_form" :rules="enterpriseRules" :model="enterprise_form" label-width="80px" size="medium">
                    <el-form-item label="企业名称" prop="com_name">
                        <el-input v-model="enterprise_form.com_name" style="width:360px;"></el-input>
                    </el-form-item>
                    <el-form-item label="品牌形象" prop="com_logo">
                        <div class="upload_wrap">
                            <div class="img_wrap">
                                <i class="el-icon-plus" v-if="!enterprise_form.com_logo&&!uploading"></i>
                                <img v-if="enterprise_form.com_logo" :src="enterprise_form.com_logo" alt="">
                                <input class="upload_file_input" ref="fileInput" accept="image/*" type="file" @change="inputUpload($event,'enterprise_form')" title="">
                                <div class="uploading" v-if="uploading">
                                    <img class="loading_pic" src="./img/loading.gif" alt="">
                                </div>
                            </div>
                            <div class="upload_tips">尺寸200×200，大小1M以内</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="企业简介" prop="com_desc">
                        <el-input type="textarea" v-model="enterprise_form.com_desc" rows="4" style="width:360px;"></el-input>
                    </el-form-item>
                    <el-form-item label="行业类型" prop="com_type">
                        <el-select v-model="enterprise_form.com_type" style="width:360px;" placeholder="请选择行业类型">
                            <el-option v-for="item in type_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="com_phone">
                        <el-input v-model="enterprise_form.com_phone" style="width:360px;"></el-input>
                    </el-form-item>
                    <el-form-item label="企业地址" prop="address">
                        <el-input v-model="enterprise_form.address" style="width:360px;"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="button" class="submit_btn" @click="enterpriseSubmit" :loading="saveLoading">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
		</el-dialog>
        <!-- 数据看板 -->
		<el-dialog center :visible.sync="dataVisible" @close="showUserInfoPop" width="780px" :show-close="false" :destroy-on-close="true">
			<div class="dialog_title" slot="title">
				<div class="title_text">数据看板</div>
				<div class="close_btn" @click="dataVisible = false"><img class="close_icon" src="./img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content data_panel">
                <div class="panel_left">
                    <div class="card_group">
                        <el-card class="card_item">
                            <div class="data_num">{{ panelData.total_writes }}</div>
                            <div class="data_label">团队累计创作文档</div>
                        </el-card>
                        <el-card class="card_item">
                            <div class="data_num">{{ panelData.total_write_words }}</div>
                            <div class="data_label">团队累计创作字数</div>
                        </el-card>
                        <el-card class="card_item">
                            <div class="data_num">{{ panelData.today_writes }}</div>
                            <div class="data_label">今日累计创作文档</div>
                        </el-card>
                        <el-card class="card_item">
                            <div class="data_num">{{ panelData.today_write_words }}</div>
                            <div class="data_label">今日累计创作字数</div>
                        </el-card>
                    </div>
                    <el-card class="card_panel">
                        <div class="progress">
                            <svg class="progress_svg">
                                <circle cx="130" cy="130" r="125" stroke="#eeeeee" stroke-width="10" fill="none" stroke-dasharray="392" stroke-dashoffset="-392" stroke-linecap="round" />
                                <circle cx="130" cy="130" r="125" stroke="#1fc770" stroke-width="10" fill="none" :stroke-dasharray="`${392*panelData.today_progress/100} 392`" stroke-dashoffset="-392" stroke-linecap="round" />
                            </svg>
                            <div class="progress_text">
                                <div class="progress_num">{{ panelData.today_progress }}%</div>
                                <div class="data_label">今日还剩余 {{ panelData.today_left_words }} 字</div>
                            </div>
                        </div>
                        <div class="vip_end_time">企业会员到期时间：{{ panelData.vip_end_date }}</div>
                    </el-card>
                </div>
                <div class="panel_right menber_content">
                    <el-menu :default-active="activeIndex" class="data_menu" mode="horizontal" @select="handleSelect">
                        <el-menu-item index="1">周榜</el-menu-item>
                        <el-menu-item index="2">月榜</el-menu-item>
                        <el-menu-item index="3">季榜</el-menu-item>
                        <el-menu-item index="4">年榜</el-menu-item>
                        <el-menu-item index="5">总榜</el-menu-item>
                    </el-menu>
                    <div class="menber_table">
                        <el-scrollbar class="write_scrollbar">
                            <el-table :data="panel_menber_data" style="width: 100%">
                                <el-table-column type="index" width="40"></el-table-column>
                                <el-table-column label="成员">
                                    <template slot-scope="scope">
                                        <img class="user_portrait" :src="scope.row.avatarurl?scope.row.avatarurl:df_avatar" alt="">
                                        {{ scope.row.real_name }}
                                        <span :class="['menber_type',{'manager':scope.row.type==1}]">{{ scope.row.type==1?"管理员":"成员" }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="answer_word_num" width="80" align="right" label="字数"></el-table-column>
                            </el-table>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
		</el-dialog>
        <!-- 邀请成员 -->
        <el-dialog :visible.sync="inviteVisible" @close="showUserInfoPop" width="780px" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">邀请成员</div>
				<div class="close_btn" @click="inviteVisible = false"><img class="close_icon" src="../views/img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content invite_manber">
                <div class="link_condition">
                    <div class="share_link condition_item">
                        <div class="link_wrap">
                            <div class="link_text">{{ share_link }}</div>
                            <div class="link_btn" @click="changeShareLink">换一换</div>
                        </div>
                        <button @click="copytext" class="copy_btn">复制链接</button>
                    </div>
                    <div class="validity condition_item">
                        <div class="password_label">设置文档分享有效期，不设置默认为一天</div>
                        <el-radio-group @change="redioChange" v-model="expired_day" size="small">
                            <el-radio-button :label="7">七天</el-radio-button>
                            <el-radio-button :label="15">十五天</el-radio-button>
                            <el-radio-button :label="30">三十天</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="condition_item">温馨提示：建议把邀请链接用微信发给成员，可以免登录直接加入企业</div>
                </div>
            </div>
		</el-dialog>
        <!-- 交流社区 -->
        <el-dialog :visible.sync="communicationVisible" @close="showUserInfoPop" width="780px" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">交流社区</div>
				<div class="close_btn" @click="communicationVisible = false"><img class="close_icon" src="../views/img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content communication">
                <div class="top_text">
                    <p>为了打造一个高质量的写作用户交流社区，避免广告滥发和刷屏等问题，懒人办公目前只对付费用户开放交流微信群，希望通过这种方式确保交流社区的质量，从而为用户提供一个优质的交流平台。感谢您的理解与支持！</p>
                    <p>每周不定时在微信群分享Ai写作教程，紧跟人工智能步伐，提高工作写作效率，让您事半功倍！</p>
                </div>
                <div class="bottom_part">
                    <div class="bottom_left">
                        <div class="qun_info">
                            <img class="qun_icon" src="./img/img_icon_103.jpg" alt="">
                            <div class="info_right">
                                <div class="qun_name">懒人办公用户交流群<span>（禁广告）</span></div>
                                <div class="qun_count">超过100000+人加入</div>
                            </div>
                        </div>
                        <div class="code_wrap">
                            <img class="code_img" src="./img/img_icon_90.jpg" alt="">
                            <div class="code_cover">
                                <div class="unsuport">暂不支持</div>
                                <div>您还不是付费会员</div>
                                <el-button size="small" type="primary" plain>升级会员</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="bottom_right">
                        <div class="text_label">微信交流群用户须知：</div>
                        <div class="text_content">
                            01、请务必遵从群规，正常学习交流！<br/>
                            02、严禁发布广告，散播不实言论等违法信息！<br/>
                            03、严禁发布涉政，涉黄等低俗违法信息！<br/>
                            04、被踢或主动退出交流群，不得再次入群请谨慎！
                        </div>
                    </div>
                </div>
            </div>
		</el-dialog>
        <pwapanel v-if="deferredPrompt" ref="pwapanel"></pwapanel>
        <authentication type="1" ref="authentication" @showUserInfoPop="showUserInfoPop"></authentication>
        <keyexchange ref="keyexchange" @showUserInfoPop="showUserInfoPop"></keyexchange>
        <freemenber ref="freemenber" @showUserInfoPop="showUserInfoPop"></freemenber>
    </div>
</template>
<script type="text/ecmascript-6">
    import pwapanel from "COMPONENTS/PwaPanel.vue"
    import authentication from "COMPONENTS/Authentication.vue"
    import keyexchange from "COMPONENTS/KeyExchange.vue"
    import freemenber from "COMPONENTS/FreeMenber.vue"
    
    export default {
        components:{pwapanel,authentication,keyexchange,freemenber},
        data() {
            return {
                app_name:"",
                df_avatar:require("./img/img_icon_17.png"),
                showVipPopup:false,
                openType:1,
                drawer:false,
                appCateList:[],
                activeNav:0,
                examp_list:[],
                myFaveriteTemplatelist:[
                    {app_id:31,app_name:"文章改写", app_icon:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/202310/17/20231017182344355121.png"},
                    {app_id:23,app_name:"多语种翻译", app_icon:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/202310/17/20231017172514331525.png"}
                ],
				noticeVisible:false,
                menberVisible:false,
                menber_list:[],
                settingVisible:false,
                setting_form:{
                    identity:1,
                    real_name:"",
                    avatarurl:"",
                    phone:"",
                    email:"",
                    address:""
                },
                settingRules:{
                    real_name:[
                        { required: true, message: '请输入昵称', trigger: 'blur' }
                    ],
                    avatarurl:[
                        { required: true, message: '请上传头像', trigger: 'change' }
                    ],
                    phone:[
                        { required: true, message: '请输入联系电话', trigger: 'blur' }
                    ],
                    email:[
                        { required: true, message: '请输入邮箱', trigger: 'blur' }
                    ],
                    address:[
                        { required: true, message: '请输入联系地址', trigger: 'blur' }
                    ],
                },
                joinCompany:{},
                enterpriseVisible:false,
                enterprise_form:{
                    com_name:"",
                    com_logo:"",
                    com_desc:"",
                    com_type:"",
                    com_phone:"",
                    address:""
                },
                enterpriseRules:{
                    com_name:[
                        { required: true, message: '请输入企业名称', trigger: 'blur' }
                    ],
                    com_logo:[
                        { required: true, message: '请上传品牌形象', trigger: 'change' }
                    ],
                    com_desc:[
                        { required: true, message: '请输入企业简介', trigger: 'blur' }
                    ],
                    com_type:[
                        { required: true, message: '请选择行业类型', trigger: 'change' }
                    ],
                    com_phone:[
                        { required: true, message: '请输入联系电话', trigger: 'blur' }
                    ],
                    address:[
                        { required: true, message: '请输入企业地址', trigger: 'blur' }
                    ],
                },
                type_options:[
                    {value:"金融",label:"金融"},
                    {value:"教育",label:"教育"},
                    {value:"石油",label:"石油"},
                    {value:"烟草",label:"烟草"},
                    {value:"自由职业者",label:"自由职业者"},
                ],
                uploading:false,
                panelData:{
                    today_left_words: 0,
                    today_write_words: 0,
                    today_writes: 0,
                    total_writes: 0,
                    today_progress:68,
                    vip_end_date:"2024-09-23"
                },
                panel_menber_data:[
                   
                ],
                dataVisible:false,
                activeIndex:"1",
                inviteVisible:false,
                share_link:"",
                expired_day:"",
                profileData:{
                    today_left_words: 0,
                    today_write_words: 0,
                    today_writes: 0,
                    total_writes: 0
                },
                deferredPrompt:null,
                identity:1,
                authIdentify:{}, // 认证信息
                saveLoading:false,
                communicationVisible:false
            }
        },
        computed:{
            userInfo(){
                return this.$store.state.userInfo;
            },
            isLogin(){
                return this.$store.state.isLogin;
            }
        },
        created() {
            this.fetchProfile()
            this.fetchAppCates()
            this.fetchMyFaverite()
            this.fetchProfileData()
            
        },
        mounted(){
            if(this.isLogin){
                setTimeout(()=>{
                    this.deferredPrompt = deferredPrompt;
                    if(deferredPrompt){
                        this.$nextTick(()=>{
                            this.$refs.pwapanel.show();
                        })
                    }
                },1000)
            }
            // this.$refs.authentication.show();
        },
        methods: {
            showApps(){
                this.drawer = true
                this.fetchAppCates()
            },
            fetchAppCates(){
                // 应用分类
                this.$http.get('/front/aixz/app/cates/').then(res =>{
                    if(res.status=='200'){
						this.appCateList = res.data
                        if(this.appCateList.length>0){
                            this.fetchAppsByCate(this.appCateList[0].id, 0)
                        }
                    }
                })
            },
            fetchAppsByCate(app_cate_id, idx){
                // 分类下模板
                this.activeNav = idx
                this.$http.get(`/front/aixz/app/template/?app_cate_id=${app_cate_id}`).then(res =>{
                    if(res.status=='200'){
						this.examp_list = res.data.data
                    }
                })
            },
            fetchProfile(){
                let search = JSON.parse(localStorage.getItem("search"));
				let invite_code = search&&search.invite_code||"";
				let team_code = localStorage.getItem("team_code")||"";
				this.$http.get('/front/aixz/profile/',{params:{invite_code:invite_code, team_code:team_code, app_id:APP_ID}}).then(res =>{
					if(res.status=='200'){
						this.$store.commit("setUserInfo",res.data);
						this.$store.commit("setIsLogin",true);
                        let showNotice = localStorage.getItem("showNotice")||"";
                        if(res.data.notice.show_notice==1&&!showNotice){
                            this.noticeVisible = true
                        }
                        this.identity = res.data.utype
                        if(res.data.company_id>0){
                            this.identity = 4
                        }
                        console.log("==", this.identity)
                        this.fetchAuthIdentify()
                        this.fetchMyJoinCompany()
					}else{
						this.$toast(res.message)
					}
				}).finally(()=>{
					this.isRouterAlive = true;
				})
            },
            fetchProfileData(){
                // 个人数据
                this.$http.get('/front/aixz/profile/data/').then(res =>{
                    if(res.status=='200'){
						this.profileData = res.data
                    }
                })
                // 企业资料
                this.fetchProfileCompany()
            },
            fetchProfileCompany(){
                // 我创建的企业
                this.$http.get('/front/aixz/compay/my/').then(res =>{
                    if(res.status=='200'){
                        if(res.data) this.enterprise_form = res.data
                    }
                })
            },
            fetchMyJoinCompany(){
                // 我加入的企业
                this.$http.get('/front/aixz/compay/myjoin/').then(res =>{
                    if(res.status=='200'){
                        if(res.data) this.joinCompany = res.data
                    }
                })
            },
            fetchAuthIdentify(){
                // 认证资料
                this.$http.get('/front/aixz/auth/identify/').then(res =>{
                    if(res.status=='200'){
                        if(res.data){
                            this.authIdentify = res.data
                        }
                    }
                })
            },
            selectIdentity(identity, type_name){
                // 切换身份
                console.log("selectIdentity", identity, type_name,this.joinCompany.company_id,this.authIdentify)
                if(this.joinCompany.company_id){
                    // 加入过企业
                    if(identity==4||identity==1){
                        // 审核通过进行企业身份切换或个人身份切换
                        this.$http.put('/front/aixz/profile/data/',{company_id:identity==4?this.joinCompany.company_id:0}).then(res =>{
                            if(res.status=='200'){
                                this.fetchProfile()
                                this.fetchProfileData()
                            }
                        })
                    }else{
                        this.$toast("您当前已经有企业身份，不能切换学生或教师身份");
                    }
                }else if(this.authIdentify.id){
                    // 提交过资料
                    if(this.authIdentify.utype==4&&identity==2){
                        this.$toast("您当前已经有企业身份，不能切换学生身份");
                    }else if(this.authIdentify.utype==4&&identity==3){
                        this.$toast("您当前已经有企业身份，不能切换教师身份");
                    }else if(this.authIdentify.utype==2&&identity==4){
                        this.$toast("您当前已经有学生身份，不能切换企业身份");
                    }else if(this.authIdentify.utype==2&&(identity==3||identity==1)){
                        this.$toast("您当前已经有学生身份，不能切换教师或个人身份");
                    }else if(this.authIdentify.utype==3&&identity==4){
                        this.$toast("您当前已经有教师身份，不能切换企业身份");
                    }else if(this.authIdentify.utype==3&&(identity==2||identity==1)){
                        this.$toast("您当前已经有教师身份，不能切换学生或个人身份");
                    }else if(this.authIdentify.status!==1){
                        // 未审核通过的 需要显示
                        this.identity = 1
                        this.$refs.authentication.show(identity)
                    }else if(this.authIdentify.utype==4&&(identity==4||identity==1)&&this.authIdentify.status==1){
                        // 审核通过进行企业身份切换或个人身份切换
                        this.$http.put('/front/aixz/profile/data/',{company_id:identity==4?this.joinCompany.company_id:0}).then(res =>{
                            if(res.status=='200'){
                                this.fetchProfile()
                            }
                        })
                    }
                }else{
                    // 未选择认证身份
                    if(identity==1){
                        this.$http.put('/front/aixz/profile/data/',{company_id:0}).then(res =>{
                            if(res.status=='200'){
                                this.fetchProfile()
                            }
                        })
                    }else{
                        this.$refs.authentication.show(identity)
                    }
                }
            },
            fetchMyFaverite(){
                // 我已收藏应用模板
                this.$http.get(`/front/aixz/user/template/`).then(res =>{
                    if(res.status=='200'){
                        console.log("====", res)
                        this.myFaveriteTemplatelist = res.data.data
                    }
                })
            },
            delMyFaverite(index){
                // 收藏应用模板
                this.$http.delete(`/front/aixz/user/template/${this.myFaveriteTemplatelist[index].id}/`).then(res =>{
                    if(res.status=='200'){
                        this.myFaveriteTemplatelist.splice(index, 1)
                    }
                })
            },
            addMyFaverite(app){
                // 收藏应用模板
                this.$http.post(`/front/aixz/user/template/`,{template_id:app.app_id}).then(res =>{
                    if(res.status=='200'){
                        app.is_faverite = 1
                        this.fetchMyFaverite()
                    }
                })
            },

            showPcDesk(){
                this.$refs.deskapp.show();//安装桌面应用弹窗
            },
            closeNitice(){
                // 关闭通知
                localStorage.setItem("showNotice", 1)
                this.noticeVisible = false
            },
            showVip(type){
                if(!this.isLogin){
                    this.$showLogin();
                    return;
                }
                if(type == 2){
                    if(this.userInfo.is_vip==0){
                        // this.$toast("4.0字数包仅支持会员购买");
                        this.$refs.updatepanel.show();
                        return;
                    }
                }
            },
            
            showMenber(){
                //获取成员列表
                this.$http.get('/front/aixz/compay/user/?company_id='+this.enterprise_form.id).then(res =>{
                    if(res.status=='200'){
						this.menber_list = res.data.item_list
                    }
                })
                this.menberVisible=true;
            },
            showDataPanel(){
                //获取数据面板数据
                this.$http.get(`/front/aixz/compay/${this.enterprise_form.id}/`).then(res =>{
                    if(res.status=='200'){
                        this.panelData = res.data
                    }
                })
                this.dataVisible=true;
            },
            showKeyExchange(){
                this.$refs.keyexchange.show();
            },
            showFreeMenber(){
                // this.$refs.freemenber.show();
                this.$toast("该功能近期上线，敬请期待！")
            },
            showCommunication(){
                // this.communicationVisible = true
                this.$toast("该功能近期上线，敬请期待！")
            },
            handleSelect(id){
                this.$http.get('/front/aixz/compay/user/data/?company_id='+this.enterprise_form.id).then(res =>{
                    if(res.status=='200'){
						this.panel_menber_data = res.data.item_list
                    }
                })
            },
            gotoPay(){
                this.$refs.userInfoPop.doClose()
                this.$router.push("/membership")
            },
            showInvite(){
                this.$http.get(`/front/aixz/compay/invite/`).then(res =>{
                    if(res.status=='200'){
                        this.share = res.data
                        this.share_link = MAIN_URLROOT +"/share/member/?code="+ this.share.invite_code
                        if(this.share.password){
                            this.password = this.share.password
                            this.enable_pwd = this.share.enable_pwd
                            this.need_password = this.enable_pwd == 1 ? true:false
                        }
                        this.expired_day = this.share.expired_day + ""
                        this.inviteVisible = true;
                    }
                })
                // this.inviteVisible = true;
            },
            showUserInfoPop(){
                setTimeout(()=>{
                    this.$refs.userInfoPop.doShow();
                },10)
            },
            copytext () {
                const el = document.createElement('textarea')
                el.setAttribute('readonly', 'readonly')
                el.style.position = 'absolute'
                el.style.left = '-9999px'
                el.value = this.share_link;
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                this.$toast("复制成功");
            },
            changeShareLink(){
                this.$http.put(`/front/aixz/compay/invite/`).then(res =>{
                    if(res.status=='200'){
                        this.$toast("更换成功");
                        this.share = res.data
                        this.share_link = MAIN_URLROOT +"/share/member/?code="+ this.share.invite_code
                        if(this.share.password){
                            
                            this.password = this.share.password
                            this.enable_pwd = this.share.enable_pwd
                            this.need_password = this.enable_pwd == 1 ? true:false
                        }
                        this.expired_day = this.share.expired_day + ""
                    }
                })
                
            },
            redioChange(val){
                this.expired_day = val
                this.$http.post(`/front/aixz/compay/invite/`,{article_id:this.article_id, expired_day:this.expired_day, enable_pwd:this.enable_pwd, password:this.password}).then(res =>{
                    if(res.status=='200'){
                        this.$toast("设置成功");
                    }
                })
            },
            removeMenber(id){
                this.$confirm('确定要移动此团队成员吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                    this.$http.delete(`/front/aixz/compay/user/`,{params:{id:id}}).then(res=>{
                        this.showMenber()
                    })
                })
            },
            
            checkLogin(){
                // 检查登录状态
                if(!this.isLogin){
                    this.$showLogin();
                    return;
                }
            },
            changeNav(e){
                if(this.userInfo.is_vip==0){
                    e.preventDefault();
                    this.$refs.updatepanel.show();
                }
            },
            searchApp(){
                this.$http.get(`/front/aixz/app/template/?app_name=${this.app_name}`).then(res =>{
                    if(res.status=='200'){
						this.examp_list = res.data.data
                    }
                })
            },
            vipUpdate(from){
                console.log("组件传来的值："+from);
                this.showVip(1)
            },
            selectExample(ex){
                this.$router.push("/essaywriting?tplid="+ex.app_id);
                this.drawer = false;
            },
            
            showSetting(){
                // 设置资料
                if(this.userInfo.company_id>0 && this.userInfo.company_id == this.enterprise_form.id){
                    this.enterpriseVisible = true; // 企业
                    this.$http.get('/front/aixz/compay/my/').then(res =>{
                        if(res.status=='200'){
                            this.enterprise_form = res.data
                        }
                    })
                }else{
                    this.settingVisible = true // 个人
                    this.$http.get('/front/aixz/authuser/').then(res =>{
                        if(res.status=='200'){
                            this.setting_form = res.data
                        }
                    })
                }
                
            },
            settingSubmit(){
                this.$refs.setting_form.validate((valid) => {
                    if (valid) {
                        // this.settingVisible = false;
                        this.saveLoading = true
                        this.$http.put('/front/aixz/authuser/', this.setting_form).then(res =>{
                            if(res.status=='200'){
                                this.$message({
                                    message: '修改成功！',
                                    type: 'success'
                                });
                            }
                        }).catch(res => {
                            this.$message({
                                    message: res.result,
                                    type: 'error'
                                });
                        }).finally(()=>{
                            this.saveLoading = false
                        })
                    }
                });
            },
            enterpriseSubmit(){
                this.$refs.enterprise_form.validate((valid) => {
                    if (valid) {
                        this.saveLoading = true
                        this.$http.post('/front/aixz/compay/', this.enterprise_form).then(res =>{
                            if(res.status=='200'){
                                this.$message({
                                    message: '修改成功！',
                                    type: 'success'
                                });
                            }
                            this.fetchProfileCompany()
                        }).catch(res => {
                            this.$message({
                                message: res.result,
                                type: 'error'
                            });
                        }).finally(()=>{
                            this.saveLoading = false
                        })
                        // this.enterpriseVisible = false;
                    }
                });
            },
            inputUpload(e,type){
                let files = e.target.files;
                if(files.length > 1){
                    this.$message({
                        message: '仅支持单个文件上传',
                        type: 'warning'
                    })
                    return
                }
                let file = files[0];
                if(file.type != "image/jpeg" && file.type != "image/png"){
                    this.$message({
                        message: '仅支持JPG、PNG格式图片',
                        type: 'warning'
                    })
                    return
                }
                if(file.size > 15*1024*1024){
                    this.$message({
                        message: '请上传15M以内的图片',
                        type: 'warning'
                    })
                    return
                }
                this.uploadFile(file,type)
                this.$refs.fileInput.value = "";
            },
            async uploadFile(file,type){
                this.uploading = true
                let post_url = await this.$http.get(`${FILE_API_SERVER}/api/front/upload/?file_folder=mj_iw`).then(res => {
                    return res.data
                }).catch(e => {
                    return ""
                });
                if (!post_url) {
                    this.$message({
                        message: '很抱歉，系统出错，请重新上传！',
                        type: 'warning'
                    })
                    return
                }
                // 上传图片
                let formData = new FormData();
                formData.append("file", file, file.name);
                let fileResponse = await this.$http.post(post_url+"&storage=ali_oss", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    responseType: "text"
                }).then(res => {
                    return eval(res);
                }).catch(e => {
                    return "";
                });
                this.uploading = false;
                if(type == "setting_form"){
                    this.setting_form.avatarurl = fileResponse.data.file_full_url;
                }else if(type == "enterprise_form"){
                    this.enterprise_form.com_logo = fileResponse.data.file_full_url;
                    this.$refs.enterprise_form.validateField('logo');
                }
            },
            logout(){
                this.$confirm('确定要退出当前账号？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.$store.commit("setIsLogin",false);
                    this.$store.commit("setUserInfo",{});
                    localStorage.clear();
                    location.replace("/")
                }).catch(() => {});
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #lrbg_layout{
        width: 100vw;
        height: 100vh;
        .lrbg_container{
            display: flex;
            width: 100vw;
            height: 100vh;
            min-width: 1280px;
            min-height: 740px;
            background-color: #f5f5f5;
            overflow: hidden;
            .lrbg_aside{
                width: 240px;
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                z-index: 5;
                .aside_part{
                    padding-left: 16px;
                    border-bottom: 1px solid #e5e5e5;
                    padding-bottom: 5px;
                    &.flex_grow1{
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        overflow: hidden;
                        .aside_title{
                            flex-shrink: 0;
                        }
                        .nav_list{
                            overflow: hidden;
                            flex-grow: 1;
                            .aside_nav{
                                height: 100%;
                                .nav_content{
                                    position: relative;
                                    &:hover{
                                        .delete_icon{
                                            display: block;
                                        }
                                    }
                                    .delete_icon{
                                        position: absolute;
                                        width: 16px;
                                        height: 16px;
                                        top: 12px;
                                        right: 10px;
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                    .aside_logo{
                        padding-top: 20px;
                        margin-bottom: 12px;
                        .logo_img{
                            width: 100%;
                        }
                    }
                    .aside_title{
                        color: #999;
                        line-height: 50px;
                        padding-top: 8px;
                        .title_icon{
                            float: right;
                            width: 16px;
                            margin-top: 17px;
                            cursor: pointer;
                        }
                    }
                    .aside_nav{
                        padding-bottom: 8px;
                        .nav_item{
                            display: block;
                            &.active{
                                background-color: #e5e5e5;
                            }
                            &:last-child{
                                .nav_content{
                                    margin-bottom: 0;
                                }
                            }
                            .more_app{
                                cursor: pointer;
                            }
                            .nav_content{
                                height: 42px;
                                padding-left: 16px;
                                margin-bottom: 5px;
                                border-radius: 3px;
                                display: flex;
                                align-items: center;
                                &:hover{
                                    background-color: #e5e5e5;
                                }
                                .nav_icon{
                                    width: 16px;
                                    margin-right: 5px;
                                    margin-top: 1px;
                                }
                            }
                        }
                    }
                }
                .user_info{
                    height: 62px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    padding-left: 32px;
                    position: relative;
                    &:hover{
                        .user_wrapper{
                            display: block;
                        }
                    }
                    .avatar{
                        width: 16px;
                        height: 16px;
                        display: block;
                        flex-shrink: 0;
                        margin-right: 10px;
                    }
                    .user_info_right{
                        flex-grow: 1;
                        .no_login{
                            color: #07c160;
                        }
                        .is_login{
                            display: flex;
                            width: 100%;
                            .info_detail{
                                flex-grow: 1;
                                overflow: hidden;
                                display: flex;
                                align-items: center;
                                .user_name{
                                    font-weight: bold;
                                    display: flex;
                                    font-size: 14px;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                                .vip_icon{
                                    display: block;
                                    flex-shrink: 0;
                                    width: 14px;
                                    height: 17px;
                                    background-size: 100% 100%;
                                    margin: 0 4px;
                                    &.is_vip_0{
                                        background-image: url("./img/vip_type_0.png");
                                    }
                                    &.is_vip_1{
                                        background-image: url("./img/vip_type_1.png");
                                    }
                                    &.is_vip_2{
                                        background-image: url("./img/vip_type_2.png");
                                    }
                                    &.is_vip_3{
                                        background-image: url("./img/vip_type_3.png");
                                    }
                                    &.is_vip{
                                        background-image: url("./img/vip_type_1.png");
                                    }
                                    &.no_vip{
                                        background-image: url("./img/vip_type_0.png");
                                    }
                                }
                                .user_tag{
                                    width: 35px;
                                    height: 16px;
                                    border-radius: 3px;
                                    background-color: #424242;
                                    color: #fff;
                                    font-size: 12px;
                                    text-align: center;
                                    line-height: 16px;
                                }
                            }
                            .notice_badge{
                                position: relative;
                                .notice_icon{
                                    display: block;
                                    width: 18px;
                                }
                                .badge_num{
                                    min-width: 14px;
                                    padding: 0 3px;
                                    height: 14px;
                                    font-size: 12px;
                                    text-align: center;
                                    line-height: 14px;
                                    border-radius: 7px;
                                    color: #fff;
                                    position: absolute;
                                    top: -12px;
                                    right: -10px;
                                    background-color: #f00;
                                }
                            }
                        }
                    }
                }
            }
            .lrbg_main{
                flex-grow: 1;
                overflow-y: auto;
            }
        }
    }
    .user_info_pabel{
        padding: 12px 20px;
        border-radius: 4px;
        .panel_top{
            height: 52px;
            display: flex;
            align-items: center;
            border-bottom: 1px dashed #ccc;
            position: relative;
            padding-bottom: 12px;
            .panel_avatar{
                display: block;
                width: 36px;
                height: 36px;
                margin-right: 10px;
                border-radius: 18px;
            }
            .panel_user_info{
                flex-grow: 1;
                overflow: hidden;
                .user_name{
                    display: flex;
                    align-items: center;
                    .name_text{
                        font-size: 14px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        display: block;
                        overflow: hidden;
                    }
                    .vip_icon{
                        display: block;
                        flex-shrink: 0;
                        width: 14px;
                        height: 17px;
                        background-size: 100% 100%;
                        margin: 0 4px;
                        &.is_vip_0{
                                        background-image: url("./img/vip_type_0.png");
                                    }
                                    &.is_vip_1{
                                        background-image: url("./img/vip_type_1.png");
                                    }
                                    &.is_vip_2{
                                        background-image: url("./img/vip_type_2.png");
                                    }
                                    &.is_vip_3{
                                        background-image: url("./img/vip_type_3.png");
                                    }
                        &.is_vip{
                            background-image: url("./img/img_icon_15.png");
                        }
                        &.no_vip{
                            background-image: url("./img/img_icon_16.png");
                        }
                    }
                    .user_tag{
                        width: 35px;
                        height: 16px;
                        border-radius: 3px;
                        background-color: #424242;
                        color: #fff;
                        font-size: 12px;
                        text-align: center;
                        line-height: 16px;
                    }
                }
                .user_desc{
                    color: #999;
                    font-size: 11px;
                }
            }
            .exchange_btn{
                width: 110px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 3px;
                background-color: #fff;
                cursor: pointer;
                box-shadow: 0 0 10px 2px #ddd;
                .exchange_icon{
                    width: 18px;
                    margin-right: 8px;
                }
            }
            .manager_icon{
                position: absolute;
                top: -12px;
                right: -20px;
                display: block;
            }
        }
        .panel_content{
            padding: 20px 0;
            .compony_btns{
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
                .btn_item{
                    width: 106px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 3px;
                    background-color: #fff;
                    cursor: pointer;
                    box-shadow: 0 0 10px 2px #ddd;
                    .btn_icon{
                        width: 16px;
                        margin-right: 9px;
                    }
                }
            }
            .vip_level{
                height: 38px;
                line-height: 38px;
                padding: 0 12px;
                font-size: 12px;
                background-color: #eee;
                border-radius: 3px;
                margin-bottom: 18px;
                .vip_btn{
                    float: right;
                    color: #07c160;
                    text-decoration: underline;
                    cursor:pointer;
                }
            }
            .vip_content{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .content_item{
                    margin-bottom: 18px;
                    width: 168px;
                    height: 88px;
                    box-shadow: 0 0 10px 2px #ddd;
                    border-radius: 5px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    .item_num{
                        line-height: 32px;
                        font-size: 16px;
                    }
                    .item_label{
                        line-height: 28px;
                        font-size: 12px;
                        color: #ccc;
                    }
                }
            }
            .server_part{
                height: 80px;
                border: 1px solid #e5e5e5;
                background-color: #f5f5f5;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .server_label{
                    line-height: 30px;
                    font-size: 14px;
                    .server_icon{
                        width: 20px;
                        margin-right: 10px;
                        vertical-align: middle;
                        margin-top: -2px;
                    }
                }
                .server_time{
                    font-size: 12px;
                    line-height: 28px;
                    color: #ccc;
                }
            }
        }
        .panel_footer{
            padding-top: 12px;
            border-top: 1px dashed #ccc;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .footer_btn{
                display: flex;
                align-items: center;
                font-size: 14px;
                cursor: pointer;
                .setting_icon{
                    width: 16px;
                    margin-right: 8px;
                    margin-top: -2px;
                }
            }
        }
    }
    .about_us{
        padding: 12px 32px;
        .about_title{
            padding-bottom: 6px;
            font-size: 14px;
            line-height: 54px;
        }
        .about_content{
            text-indent: 2em;
            font-size: 14px;
            line-height: 26px;
            color: #999;
            .content_p{
                margin-bottom: 26px;
            }
        }
        .about_footer{
            font-size: 14px;
            color: #999;
            padding-top: 12px;
            border-top: 1px dashed #ccc;
            line-height: 54px;
        }
    }
    .app_drawer{
        position: fixed;
        width: 100%;
        height: 70vh;
        left: 0;
        bottom: 0;
        z-index: 2501;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        .drawer_close{
            position: absolute;
            top: -95px;
            left: 50%;
            margin-left: -80px;
            .close_btn{
                width: 160px;
                height: 56px;
                border-radius: 4px;
                background-color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                .close_icon{
                    width: 16px;
                    margin-right: 14px;
                }
            }
            .down_icon{
                display: block;
                width: 20px;
                margin: 10px auto 0;
            }
        }
        .drawer_top{
            height: 120px;
            flex-shrink: 0;
            display: flex;
            padding: 0 10px;
            align-items: center;
            box-shadow: 0px 3px 3px -3px #e5e5e5;
            .app_nav{
                flex-grow: 1;
                display: flex;
                justify-content: space-between;
                padding-right: 24px;
                .nav_item{
                    width: 80px;
                    color: #999;
                    text-align: center;
                    cursor: pointer;
                    &.active{
                        color: #07c160;
                        position: relative;
                        font-weight: bold;
                        .nav_title{
                            &::after{
                                content: "";
                                display: block;
                                width: 100%;
                                border-bottom: 2px solid #07c160;
                                position: absolute;
                                left: 50%;
                                margin-left: -50%;
                                bottom: -25px;
                            }
                        }
                    }
                    >>> .el-badge__content{
                            background-color: #07c160;
                        }
                    .nav_icon{
                        width: 46px;
                        height: 46px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            display: block;
                            width: 24px;
                        }
                       
                    }
                    .nav_title{
                        line-height: 24px;
                    }
                }
            }
            .app_search{
                padding: 11px 13px;
                background-color: #f5f5f5;
                .search_wrap{
                    width: 450px;
                    height: 46px;
                    border-radius: 4px;
                    border: 1px solid #e5e5e5;
                    background-color: #fff;
                    padding: 0 12px;
                    display: flex;
                    align-items: center;
                    .search_input{
                        flex-grow: 1;
                        height: 100%;
                        background-color: transparent;
                        border: none;
                    }
                    .search_icon{
                        width: 24px;
                        margin-left: 10px;
                    }
                }
            }
        }
        .drawer_content{
            flex-grow: 1;
            overflow: hidden;
            .scroll_content{
                padding: 20px 24px;
                .el-col-48{
                    width: 20%;
                }
            }
            .exmple_item{
                box-shadow: 0 0 10px 3px #eee;
                border-radius: 5px;
                padding: 0 20px;
                cursor: pointer;
                .item_content{
                    border-bottom: 1px dashed #e5e5e5;
                    display: flex;
                    align-items: center;
                    height: 73px;
                    .item_icon{
                        width: 45px;
                        height: 45px;
                        display: block;
                        margin-right: 10px;
                        flex-shrink: 0;
                    }
                    .item_text{
                        flex-grow: 1;
                        line-height: 24px;
                        overflow: hidden;
                        .item_title{
                            font-weight: bold;
                        }
                        .item_desc{
                            color: #ccc;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
                .item_footer{
                    display: flex;
                    justify-content: space-between;
                    height: 36px;
                    .footer_item{
                        display: flex;
                        align-items: center;
                        font-size: 12px;
                        color: #999;
                        &.add_btn{
                            cursor: pointer;
                        }
                        .footer_icon{
                            width: 13px;
                            margin-right: 6px;
                            margin-top: 1px;
                        }
                    }
                }
            }
        }
    }
    .dialog_content{
        .menber_content{
            padding: 0 30px;
            height: 414px;
            .user_portrait{
                width: 16px;
                height: 16px;
                object-fit: cover;
                vertical-align: middle;
                margin-top: -3px;
            }
            .menber_type{
                display: inline-block;
                padding: 0 5px;
                line-height: 16px;
                height: 16px;
                font-size: 12px;
                border-radius: 2px;
                background-color: #ddd;
                color: #999;
                &.manager{
                    color: #fff;
                    background-color: #424242;
                }
            }
            .table_icon{
                width: 20px;
                cursor: pointer;
            }
        }
        &.notice_panel{
            padding: 25px 30px;
            color: #666;
            line-height: 28px;
            height: 280px;
            .notice_head{
                margin-bottom: 7px;
            }
            .notice_content{
                text-indent: 2em;
            }
            .notice_sign{
                text-align: right;
                margin-top: 60px;
            }
        }
        &.menber_panel{
            .panel_bottom{
                padding: 16px 20px;
                font-size: 14px;
                line-height: 24px;
                color: #999;
                background-color: #eee;
            }
        }
        &.form_panel{
            padding: 20px 30px 18px;
            .upload_wrap{
                display: flex;
                .img_wrap{
                    width: 90px;
                    height: 90px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #ccc;
                    border-radius: 3px;
                    position: relative;
                    margin-right: 12px;
                    i{
                        font-size: 36px;
                    }
                    img{
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    .upload_file_input{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                        z-index: 1;
                        top: 0;
                        left: 0;
                        cursor: pointer;
                    }
                    .uploading{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(255, 255, 255, 0.8);
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .loading_pic{
                            display: block;
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
                .upload_tips{
                    font-size: 12px;
                    color: #999;
                    line-height: 16px;
                    white-space: nowrap;
                    align-self: flex-end;
                }
            }
            .submit_btn{
                width: 110px;
                height: 40px;
                border: none;
                background-color: #424242;
                color: #fff;
                border-radius: 3px;
            }
        }
        &.data_panel{
            display: flex;
            padding: 0 30px;
            justify-content: space-between;
            height: 500px;
            .panel_left{
                width: 350px;
                .card_group{
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    padding-top: 24px;
                    .card_item{
                        margin-bottom: 24px;
                        width: 163px;
                        text-align: center;
                        .data_num{
                            line-height: 22px;
                            font-size: 18px;
                        }
                        .data_label{
                            font-size: 12px;
                            color: #999;
                            line-height: 20px;
                            margin-top: 6px;
                        }
                    }
                }
                .card_panel{
                    position: relative;
                    padding: 4px 24px 0;
                    .progress{
                        position: relative;
                        .progress_svg{
                            width: 100%;
                            height: 135px;
                        }
                        .progress_text{
                            position: absolute;
                            width: 100%;
                            text-align: center;
                            top: 36px;
                            left: 0;
                            .progress_num{
                                font-size: 26px;
                                width: 100%;
                                line-height: 58px;
                            }
                            .data_label{
                                font-size: 12px;
                                line-height: 36px;
                            }
                        }
                    }
                    .vip_end_time{
                        margin-top: 16px;
                        height: 26px;
                        line-height: 26px;
                        font-size: 11px;
                        background-color: #eee;
                        color: #999;
                        border-radius: 13px;
                        text-align: center;
                    }
                }
            }
            .panel_right{
                width: 300px;
                display: flex;
                padding: 10px 0 30px;
                overflow: hidden;
                flex-direction: column;
                .data_menu{
                    flex-shrink: 0;
                    /deep/.el-menu-item{
                        height: 40px;
                        line-height: 40px;
                        padding: 0 16px;
                    }
                }
                .menber_table{
                    flex-grow: 1;
                    overflow: hidden;
                    padding-top: 10px;
                }
            }
        }
        &.invite_manber{
            padding: 30px 30px 10px;
            .link_condition{
                .condition_item{
                    margin-bottom: 30px;
                    color: #424242;
                    &.share_link{
                        display: flex;
                        overflow: hidden;
                        .link_wrap{
                            flex-grow: 1;
                            margin-right: 13px;
                            height: 40px;
                            border-radius: 4px;
                            border: 1px solid #ddd;
                            padding: 0 12px;
                            line-height: 38px;
                            display: flex;
                            overflow: hidden;
                            .link_text{
                                flex-grow: 1;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                color: #999;
                                margin-right: 12px;
                            }
                            .link_btn{
                                flex-shrink: 0;
                                cursor: pointer;
                            }
                        }
                        .copy_btn{
                            width: 110px;
                            height: 40px;
                            border-radius: 4px;
                            background-color: #424242;
                            color: #fff;
                            border: none;
                        }
                    }
                    &.validity{
                        display: flex;
                        align-items: center;
                        .password_label{
                            margin-right: 16px;
                        }
                    }
                }
            }
        }
        &.communication{
            padding: 0 30px;
            .top_text{
                padding: 16px 0 6px;
                font-size: 12px;
                color: #666;
                line-height: 28px;
                text-indent: 2em;
                p{
                    margin-bottom: 10px;
                }
            }
            .bottom_part{
                display: flex;
                height: 290px;
                border-top: 1px dashed #ccc;
                .bottom_left{
                    width: 340px;
                    border-right: 1px dashed #ccc;
                    padding-top: 20px;
                    .qun_info{
                        display: flex;
                        align-items: center;
                        margin-bottom: 16px;
                        .qun_icon{
                            width: 50px;
                            height: 50px;
                            border-radius: 5px;
                            margin-right: 14px;
                            display: block;
                        }
                        .info_right{
                            flex-grow: 1;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            font-size: 12px;
                            line-height: 18px;
                            .qun_name{
                                color: #666;
                                span{
                                    color: #c00;
                                }
                            }
                            .qun_count{
                                color: #999;
                            }
                        }
                    }
                    .code_wrap{
                        width: 160px;
                        height: 160px;
                        margin-left: 60px;
                        position: relative;
                        box-shadow: 0 0 10px 3px #ddd;
                        .code_img{
                            display: block;
                            width: 100%;
                            height: 100%;
                        }
                        .code_cover{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            background-color: rgba(255, 255, 255, 0.6);
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            font-size: 12px;
                            color: #999;
                            line-height: 32px;
                            .unsuport{
                                color: #c00;
                            }
                        }
                    }
                }
                .bottom_right{
                    flex-grow: 1;
                    padding: 12px 0 0 24px;
                    font-size: 12px;
                    color: #999;
                    line-height: 34px;
                    .text_label{
                        color: #000;
                    }
                }
            }
        }
    }
    .exchange_panel{
        padding: 0 16px 6px;
        .part_title{
            color: #ccc;
            font-size: 12px;
            line-height: 22px;
            padding-top: 10px;
        }
        .part_item{
            border-bottom: 1px solid #eee;
            color: #999;
            line-height: 50px;
            cursor: pointer;
            &:last-child{
                border-bottom: none;
            }
            &.active{
                color: #07c160;
                .identy_icon{
                    display: none;
                    &.select{
                        display: inline-block;
                    }
                }
                .select_icon{
                    display: block;
                }
            }
            .identy_icon{
                width: 18px;
                vertical-align: middle;
                margin: -2px 8px 0 0;
                &.select{
                    display: none;
                }
            }
            .select_icon{
                display: none;
                width: 18px;
                float: right;
                margin-top: 16px;
            }
        }
    }
    .notice_btn{
        width: 240px;
        height: 48px;
        background-color: #424242;
        color: #fff;
        font-size: 14px;
        border-radius: 4px;
        border: none;
        margin-bottom: 20px;
    }
    .bottom_slide-enter-active, .bottom_slide-leave-active {
        transition: all .3s;
    }
    .bottom_slide-enter, .bottom_slide-leave-to {
        transform: translateY(100%);
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
